import Fetcher from "../../../libs/Petition";

const url = 'comppago/pend/prov';
const CREATED = 201;
const STATUS_OK = 200;

export const indexCompPagoPendProv = async ({ headers, ILifnr }) => {
    let response = { data: [], totalItems: 0 };
    try {
        let params = { ILifnr };
        let fetch = await Fetcher({
            url: `${url}`,
            method: 'GET',
            headers,
            params
        });
        // console.log("Comp Pago Pend Prov: ", fetch);
        if (fetch.status === STATUS_OK)
            response = fetch.data
    } catch (error) {
        response = { data: [], totalItems: 0 };
    } finally {
        return response;
    }
}